const bankIcon = [
  {
    path: '/bank-icon',
    name: 'bank-icon',
    component: () => import('@/views/bank-icon/BankIcon.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'BankIconAdmin',
    },
  },
]
export default bankIcon
